import React, { useState } from "react";
import {
  Fab,
  Zoom,
  Tooltip,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import AutoStoriesOutlinedIcon from '@mui/icons-material/AutoStoriesOutlined';
import ShoppingCartIcon from "@mui/icons-material/ShoppingCartOutlined";
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';

import { useNavigate } from "react-router-dom";

const menuItems = [
  {
    icon: <HandshakeOutlinedIcon />,
    color: "#F97316",
    url: "/TBD",
    toolTip: "Donate Toy"
  },
  {
    icon: <VideocamOutlinedIcon />,
    color: "#EFB561",
    url: "/video-add",
    toolTip: "Add Video"
  },
  {
    icon: <ShoppingCartIcon />,
    color: "#04A15B",
    url: "/TBD",
    toolTip: "Add Toy for Sale"
  },
  {
    icon: <AutoStoriesOutlinedIcon />,
    color: "#01579B",
    url: "/story-add",
    toolTip: "Add Story"
  },
];

export default function FloatingMenu( {left = null, right = null} ) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div
      style={{
        position: "fixed",
        bottom: 16,
        right: right,
        left: left,
        display: "flex",
        flexDirection: "column-reverse",
        alignItems: "center",
        gap: "12px",
        zIndex: 2000,
      }}
    >
      {/* Main red button */}
      {/* Main FAB with rotating plus */}
      <Fab
        color="error"
        onClick={() => setOpen(!open)}
        sx={{
          width: 64,
          height: 64,
          transition: "transform 0.15s ease-in-out",
          transform: open ? "rotate(45deg)" : "rotate(0deg)",
          boxShadow: "none",        // removes background shadow
          "&:hover": {
            boxShadow: "none",      // removes hover shadow too
          },
        }}
      >
        <AddIcon sx={{ fontSize: 32 }} />
      </Fab>

      {/* Menu items */}
      {menuItems.map((item, index) => (
        <Zoom
          in={open}
          key={index}
          style={{ transitionDelay: open ? `${index * 50}ms` : "0ms" }}
        >
          <Tooltip
            title={item.toolTip}
            placement="left"
            arrow
            PopperProps={{
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, -5],
                  },
                },
              ],
            }}
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: '#666',
                  color: 'white',
                  fontSize: '12px',
                  fontWeight: '500',
                  borderRadius: '4px',
                  padding: '6px 8px',
                  '& .MuiTooltip-arrow': {
                    color: '#666',
                  },
                },
              },
            }}
          >
            <Fab
              sx={{
                backgroundColor: item.color,
                color: "white",
                width: 46,
                height: 46,
                "&:hover": {
                  backgroundColor: item.color
                }
              }}
              size="medium"
              onClick={() => navigate(item.url)}
            >
              {item.icon}
            </Fab>
          </Tooltip>
        </Zoom>
      ))}
    </div>
  );
}
